var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "cw-block cw-block-gallery",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          showEdit: _vm.showEdit,
          storeEdit: _vm.storeBlock,
          closeEdit: _vm.closeEdit,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _vm.files.length !== 0
                    ? [
                        _vm.currentLayout === "carousel"
                          ? _c(
                              "div",
                              {
                                staticClass: "cw-block-gallery-content",
                                style: {
                                  height: "".concat(_vm.currentHeight, "px"),
                                },
                              },
                              [
                                _vm._l(_vm.files, function (image, index) {
                                  var _image$attributes, _image$attributes2
                                  return _c(
                                    "div",
                                    {
                                      key: image.id,
                                      ref: "images",
                                      refInFor: true,
                                      staticClass:
                                        "cw-block-gallery-slides cw-block-gallery-fade",
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cw-block-gallery-number-text",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(index + 1) +
                                              " / " +
                                              _vm._s(_vm.files.length)
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("img", {
                                        style: {
                                          height: "".concat(
                                            _vm.currentHeight,
                                            "px"
                                          ),
                                        },
                                        attrs: {
                                          src: image.meta["download-url"],
                                        },
                                        on: {
                                          load: function load($event) {
                                            if (
                                              _vm.files.length - 1 ===
                                              index
                                            ) {
                                              _vm.startGallery()
                                            }
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "cw-block-gallery-file-description",
                                          class: {
                                            "show-on-hover":
                                              _vm.currentMouseoverFileNames ===
                                              "true",
                                          },
                                        },
                                        [
                                          _vm.currentShowFileNames === "true"
                                            ? _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    image === null ||
                                                      image === void 0
                                                      ? void 0
                                                      : (_image$attributes =
                                                          image.attributes) ===
                                                          null ||
                                                        _image$attributes ===
                                                          void 0
                                                      ? void 0
                                                      : _image$attributes.name
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.currentShowFileDescription ===
                                          "true"
                                            ? _c("p", [
                                                _vm._v(
                                                  _vm._s(
                                                    image === null ||
                                                      image === void 0
                                                      ? void 0
                                                      : (_image$attributes2 =
                                                          image.attributes) ===
                                                          null ||
                                                        _image$attributes2 ===
                                                          void 0
                                                      ? void 0
                                                      : _image$attributes2.description
                                                  )
                                                ),
                                              ])
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                }),
                                _vm._v(" "),
                                _vm.currentNav === "true"
                                  ? _c("div", [
                                      _c("button", {
                                        staticClass: "cw-block-gallery-prev",
                                        attrs: {
                                          title:
                                            _vm.$gettext("Vorheriges Bild"),
                                        },
                                        on: {
                                          click: function click($event) {
                                            return _vm.plusSlides(-1)
                                          },
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("button", {
                                        staticClass: "cw-block-gallery-next",
                                        attrs: {
                                          title: _vm.$gettext("Nächstes Bild"),
                                        },
                                        on: {
                                          click: function click($event) {
                                            return _vm.plusSlides(1)
                                          },
                                        },
                                      }),
                                    ])
                                  : _vm._e(),
                              ],
                              2
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.currentLayout === "grid"
                          ? _c(
                              "div",
                              {
                                staticClass: "cw-block-gallery-content",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "cw-block-gallery-grid formatted-content",
                                  },
                                  _vm._l(_vm.files, function (image) {
                                    var _image$attributes3,
                                      _image$attributes4,
                                      _image$attributes5
                                    return _c(
                                      "figure",
                                      {
                                        key: image.id,
                                        style: {
                                          "max-width": _vm.gridWidth,
                                        },
                                      },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: image.meta["download-url"],
                                            title:
                                              image === null || image === void 0
                                                ? void 0
                                                : (_image$attributes3 =
                                                    image.attributes) ===
                                                    null ||
                                                  _image$attributes3 === void 0
                                                ? void 0
                                                : _image$attributes3.name,
                                          },
                                        }),
                                        _vm._v(" "),
                                        _vm.showDescription
                                          ? _c("figcaption", [
                                              _vm.currentShowFileNames ===
                                              "true"
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "cw-block-gallery-grid-file-name",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            image === null ||
                                                              image === void 0
                                                              ? void 0
                                                              : (_image$attributes4 =
                                                                  image.attributes) ===
                                                                  null ||
                                                                _image$attributes4 ===
                                                                  void 0
                                                              ? void 0
                                                              : _image$attributes4.name
                                                          ) +
                                                          "\n                                "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.currentShowFileDescription ===
                                              "true"
                                                ? _c(
                                                    "p",
                                                    {
                                                      staticClass:
                                                        "cw-block-gallery-grid-file-description",
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                    " +
                                                          _vm._s(
                                                            image === null ||
                                                              image === void 0
                                                              ? void 0
                                                              : (_image$attributes5 =
                                                                  image.attributes) ===
                                                                  null ||
                                                                _image$attributes5 ===
                                                                  void 0
                                                              ? void 0
                                                              : _image$attributes5.description
                                                          ) +
                                                          "\n                                "
                                                      ),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ])
                                          : _vm._e(),
                                      ]
                                    )
                                  }),
                                  0
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "courseware-tabs",
                        [
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 0,
                                name: _vm.$gettext("Einstellungen"),
                                selected: true,
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(_vm.$gettext("Layout")) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentLayout,
                                            expression: "currentLayout",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentLayout = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "carousel",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$gettext("Karussell"))
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "grid",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$gettext("Gitter"))
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "label",
                                    [
                                      _vm._v(
                                        "\n                            " +
                                          _vm._s(_vm.$gettext("Ordner")) +
                                          "\n                            "
                                      ),
                                      _c("studip-file-chooser", {
                                        attrs: {
                                          selectable: "folder",
                                          courseId: _vm.context.id,
                                          userId: _vm.userId,
                                          excludedCourseFolderTypes:
                                            _vm.excludedCourseFolderTypes,
                                        },
                                        model: {
                                          value: _vm.currentFolderId,
                                          callback: function callback($$v) {
                                            _vm.currentFolderId = $$v
                                          },
                                          expression: "currentFolderId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.currentLayout === "carousel"
                                    ? _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$gettext("Höhe")) +
                                            "\n                            "
                                        ),
                                        _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value: _vm.currentHeight,
                                              expression: "currentHeight",
                                            },
                                          ],
                                          attrs: {
                                            type: "number",
                                            min: "0",
                                            max: "800",
                                          },
                                          domProps: {
                                            value: _vm.currentHeight,
                                          },
                                          on: {
                                            input: function input($event) {
                                              if ($event.target.composing)
                                                return
                                              _vm.currentHeight =
                                                $event.target.value
                                            },
                                          },
                                        }),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.currentLayout === "grid"
                                    ? _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(
                                              _vm.$gettext("Gitter-Spalten")
                                            ) +
                                            "\n                            "
                                        ),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.currentCols,
                                                expression: "currentCols",
                                              },
                                            ],
                                            on: {
                                              change: function change($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.currentCols = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                domProps: {
                                                  value: 100,
                                                },
                                              },
                                              [_vm._v("1")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                domProps: {
                                                  value: 50,
                                                },
                                              },
                                              [_vm._v("2")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                domProps: {
                                                  value: 33,
                                                },
                                              },
                                              [_vm._v("3")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                domProps: {
                                                  value: 25,
                                                },
                                              },
                                              [_vm._v("4")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                domProps: {
                                                  value: 20,
                                                },
                                              },
                                              [_vm._v("5")]
                                            ),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "courseware-tab",
                            {
                              attrs: {
                                index: 1,
                                name: _vm.$gettext("Beschreibung"),
                              },
                            },
                            [
                              _c(
                                "form",
                                {
                                  staticClass: "default",
                                  on: {
                                    submit: function submit($event) {
                                      $event.preventDefault()
                                    },
                                  },
                                },
                                [
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$gettext("Dateinamen anzeigen")
                                        ) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.currentShowFileNames,
                                            expression: "currentShowFileNames",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentShowFileNames = $event
                                              .target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "true",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Ja")))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "false",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Nein")))]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("label", [
                                    _vm._v(
                                      "\n                            " +
                                        _vm._s(
                                          _vm.$gettext(
                                            "Dateibeschreibung anzeigen"
                                          )
                                        ) +
                                        "\n                            "
                                    ),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value:
                                              _vm.currentShowFileDescription,
                                            expression:
                                              "currentShowFileDescription",
                                          },
                                        ],
                                        on: {
                                          change: function change($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.currentShowFileDescription =
                                              $event.target.multiple
                                                ? $$selectedVal
                                                : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "true",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Ja")))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          {
                                            attrs: {
                                              value: "false",
                                            },
                                          },
                                          [_vm._v(_vm._s(_vm.$gettext("Nein")))]
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.showDescription &&
                                  _vm.currentLayout === "carousel"
                                    ? _c(
                                        "label",
                                        [
                                          _vm._v(
                                            "\n                            " +
                                              _vm._s(
                                                _vm.$gettext(
                                                  "Beschreibung erscheint bei Mouseover"
                                                )
                                              ) +
                                              "\n                            "
                                          ),
                                          _c("studip-tooltip-icon", {
                                            attrs: {
                                              text: _vm.$gettext(
                                                "Der Beschreibungstext wird angezeigt, wenn Sie den Mauszeiger über das Bild bewegen."
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "select",
                                            {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.currentMouseoverFileNames,
                                                  expression:
                                                    "currentMouseoverFileNames",
                                                },
                                              ],
                                              on: {
                                                change: function change(
                                                  $event
                                                ) {
                                                  var $$selectedVal =
                                                    Array.prototype.filter
                                                      .call(
                                                        $event.target.options,
                                                        function (o) {
                                                          return o.selected
                                                        }
                                                      )
                                                      .map(function (o) {
                                                        var val =
                                                          "_value" in o
                                                            ? o._value
                                                            : o.value
                                                        return val
                                                      })
                                                  _vm.currentMouseoverFileNames =
                                                    $event.target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "true",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$gettext("Ja"))
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "option",
                                                {
                                                  attrs: {
                                                    value: "false",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    _vm._s(_vm.$gettext("Nein"))
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.currentLayout === "carousel"
                            ? _c(
                                "courseware-tab",
                                {
                                  attrs: {
                                    index: 2,
                                    name: _vm.$gettext("Autoplay"),
                                  },
                                },
                                [
                                  _c(
                                    "form",
                                    {
                                      staticClass: "default",
                                      on: {
                                        submit: function submit($event) {
                                          $event.preventDefault()
                                        },
                                      },
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(
                                          "\n                            " +
                                            _vm._s(_vm.$gettext("Autoplay")) +
                                            "\n                            "
                                        ),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.currentAutoplay,
                                                expression: "currentAutoplay",
                                              },
                                            ],
                                            on: {
                                              change: function change($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.currentAutoplay = $event
                                                  .target.multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "true",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Ja"))
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "false",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(_vm.$gettext("Nein"))
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.currentAutoplay === "true"
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.$gettext(
                                                    "Autoplay Timer in Sekunden"
                                                  )
                                                ) +
                                                "\n                            "
                                            ),
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value:
                                                    _vm.currentAutoplayTimer,
                                                  expression:
                                                    "currentAutoplayTimer",
                                                },
                                              ],
                                              attrs: {
                                                type: "number",
                                                min: "1",
                                                max: "60",
                                              },
                                              domProps: {
                                                value: _vm.currentAutoplayTimer,
                                              },
                                              on: {
                                                input: function input($event) {
                                                  if ($event.target.composing)
                                                    return
                                                  _vm.currentAutoplayTimer =
                                                    $event.target.value
                                                },
                                              },
                                            }),
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.currentAutoplay === "true"
                                        ? _c("label", [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.$gettext("Navigation")
                                                ) +
                                                "\n                            "
                                            ),
                                            _c(
                                              "select",
                                              {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.currentNav,
                                                    expression: "currentNav",
                                                  },
                                                ],
                                                on: {
                                                  change: function change(
                                                    $event
                                                  ) {
                                                    var $$selectedVal =
                                                      Array.prototype.filter
                                                        .call(
                                                          $event.target.options,
                                                          function (o) {
                                                            return o.selected
                                                          }
                                                        )
                                                        .map(function (o) {
                                                          var val =
                                                            "_value" in o
                                                              ? o._value
                                                              : o.value
                                                          return val
                                                        })
                                                    _vm.currentNav = $event
                                                      .target.multiple
                                                      ? $$selectedVal
                                                      : $$selectedVal[0]
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "true",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(_vm.$gettext("Ja"))
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "option",
                                                  {
                                                    attrs: {
                                                      value: "false",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$gettext("Nein")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ])
                                        : _vm._e(),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.$gettext("Informationen zum Galerie-Block"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }